import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const PersianDate = ({ date }) => {
  if (!date) return null;

  const miladi = new Date(date);

  const shamsi = new DateObject({
    date: miladi,
    calendar: persian,
    locale: persian_fa,
  });

  return <span>{shamsi.format("YYYY/MM/DD HH:mm")}</span>;
};

export default PersianDate;
